import i18n from "../i18n";

export const DELIVERY_CARRIAGE_TYPE = 'carriage';

export const DELIVERY_CONTAINER_TYPE = 'container';

export const DELIVERY_DEFAULT_TYPE = 'delivery';

export const DELIVERY_AUCTION_PRICE_TYPE = 'auction_price';

export const DELIVERY_AUCTION_DATE_TYPE = 'auction_date';

export const REDUCTION_TYPE = 'reduction';

export const DELIVERY_MULTIMODAL_TYPE = 'multimodal';

export const AUCTION_MULTIMODAL_TYPE = 'auction_multimodal';

export const INCOTERM_FOB = 'fob';

export const INCOTERM_EXW = 'exw';

export const deliveryTypes = {
    delivery: i18n.t('constants.deliveryTypes.delivery'),
    auction_date: i18n.t('constants.deliveryTypes.auctionDate'),
    auction_price: i18n.t('constants.deliveryTypes.auctionPrice'),
    reduction: i18n.t('constants.deliveryTypes.reduction'),
    multimodal: i18n.t('constants.deliveryTypes.multimodal'),
    auction_multimodal: i18n.t('constants.deliveryTypes.auctionMultimodal'),
}

export const offerTitle = {
    new : i18n.t('constants.offerTitle.new'),
    agreed : i18n.t('constants.offerTitle.agreed'),
    refused : i18n.t('constants.offerTitle.refused'),
    irrelevant : i18n.t('constants.offerTitle.irrelevant'),
}

export const multimodalFlags = {
    considerTaxType: 'Только НДС 22%',
    considerOrgForm: 'Только ООО',
    considerCountry: 'Только Российские компании'
}

export const contractGroupTypes = {
    container: i18n.t('constants.contractGroupTypes.container'),
    carriage: i18n.t('constants.contractGroupTypes.carriage'),
    cross_dock: i18n.t('constants.contractGroupTypes.cross_dock'),
}
